import React, { useState } from 'react'
import tableStyles from '../../styles/tracker-modules/datatable.module.less'
import ProgressBar from './progressBar'
import { capfirst } from 'journalize'

const findWithAttr = (array, attr, value) => {
  // finds index of an object where it's property matches a value
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i
    }
  }
  return -1
}

const sortData = (list, sortByThis, direction, specials, rowHeaderKey) => {
  // sort based on direction and property given
  list.sort(function (a, b) {
    var varA = a[sortByThis]
    var varB = b[sortByThis]
    if (!direction) {
      // if going the other way
      varA = b[sortByThis]
      varB = a[sortByThis]
    }
    if (varA < varB) {
      return -1
    }
    if (varA > varB) {
      return 1
    }

    // names must be equal
    return 0
  })

  // pull out usa and state and make them first if sorting by name
  if (sortByThis === rowHeaderKey) {
    const unshiftThese = specials
    for (let i = 0; i < unshiftThese.length; i++) {
      // find index
      const theIndex = findWithAttr(list, rowHeaderKey, unshiftThese[i])
      if (theIndex > -1) {
        // it's found
        // remove object and put it on the front
        const theObject = list.splice(theIndex, 1)[0]
        list.unshift(theObject)
      }
    }
  }
  return list
}
function DataTable({
  data,
  highlight,
  maxLength,
  phase,
  rowHeaderKey,
  gaToggleEvent,
  gaSortEvent,
  dataLabels,
  highlightRow,
  stickyRowHeader = false,
  sortable = false,
  useKeys = 'all',
}) {
  let [allRowsVisible, setAllRowsVisible] = useState(false)
  let [btnText, setBtnText] = useState('Show more')
  let [sortVar, setSortVar] = useState('n')
  let [sortDirection, setSortDirection] = useState(true)

  const toggleTable = (phase) => {
    setAllRowsVisible(!allRowsVisible)
    btnText === 'Show more' ? setBtnText('Show less') : setBtnText('Show more')
    if (gaToggleEvent) {
      gaToggleEvent(btnText, phase)
    }
  }

  const sortThis = (newVar, direction, oldVar) => {
    if (newVar === oldVar) {
      // if it's the same var
      setSortDirection(!direction) // make the direction go the other way
    } else {
      // it's a new var
      setSortVar(newVar) // set new var
      setSortDirection(true) // start over with ascending
    }

    if (gaSortEvent) {
      gaSortEvent(newVar)
    }
  }

  if (sortable) {
    data = sortData(
      data,
      sortVar,
      sortDirection,
      [highlightRow, 'United States'],
      rowHeaderKey
    )
  }
  let sortableStyle = ''
  if (sortable) {
    sortableStyle = tableStyles.sortable
  }

  //if keys to use aren't explicitly set, use all available columns in the sheet besides ones
  //we know we don't want to use, which are currently: 'type of person' and  'phase_name'

  if (useKeys === 'all') {
    let skipKeys = ['type of person', 'phase_name']
    let sheetKeys = Object.keys(data[0])
    useKeys = sheetKeys.filter((d) => !skipKeys.includes(d))
  }
  return (
    <div className={tableStyles.container}>
      <table
        className={`${tableStyles.table} ${
          stickyRowHeader && tableStyles.scrollable
        }`}
      >
        <thead className={useKeys.length > 0 ? '' : 'hidden'}>
          <tr>
            {/* if this is a sortable table, there should be
          a column header on the first column. Expect that column to be in headerkeys so let the map take care of it. If it's not sortable, add an empty td here.*/}
            {!sortable && <td className={tableStyles.filler}></td>}
            {useKeys &&
              useKeys.map((key, i) => {
                let headingStyle = ''
                let stickyStyle =
                  stickyRowHeader && i === 0 ? tableStyles.sticky : ''

                if (dataLabels) {
                  if (
                    dataLabels[key].format === 'percent' ||
                    dataLabels[key].format === 'left'
                  ) {
                    headingStyle = tableStyles.alignLeft
                  } else {
                    headingStyle = tableStyles.alignRight
                  }
                }

                // add classes for sort arrow
                let activeKeyStyle = ''
                // check if we;re sorting by this key and this is a sortable table
                if (key === sortVar && sortable) {
                  // add class for up or down
                  activeKeyStyle = sortDirection
                    ? tableStyles.activeUp
                    : tableStyles.activeDown
                }

                return (
                  <th
                    key={`header-${key}`}
                    scope="col"
                    className={`${tableStyles.top} ${headingStyle} ${sortableStyle} ${activeKeyStyle} ${stickyStyle}`}
                    onClick={() => sortThis(key, sortDirection, sortVar)}
                  >
                    {dataLabels && dataLabels[key]
                      ? capfirst(dataLabels[key].label)
                      : key}
                  </th>
                )
              })}
          </tr>
        </thead>
        <tbody>
          {data.map((d, i) => (
            <tr
              key={`row-${d[rowHeaderKey]}`}
              className={
                i >= maxLength && !allRowsVisible
                  ? 'hidden'
                  : [highlightRow, 'United States'].includes(d[rowHeaderKey])
                  ? tableStyles.highlight
                  : ''
              }
            >
              <th
                className={
                  highlight
                    ? tableStyles.highlight
                    : `${tableStyles.heading} ${
                        stickyRowHeader && tableStyles.sticky
                      }`
                }
                scope="row"
              >
                {d[rowHeaderKey]}
              </th>
              {useKeys &&
                useKeys.map((key) => {
                  let val = ''
                  let bar = null
                  let style = ''
                  let labelKey = `table-${key}-${d[rowHeaderKey].replace(
                    ' ',
                    '-'
                  )}`

                  // this will be true on 'sortable' tables where we do want a header on the first column. On all tables, the first column is already created with the rowHeaderKey. Not doing this creates a cell twice
                  if (key === rowHeaderKey) {
                    return
                  }
                  if (dataLabels) {
                    // val = dataLabels[key]
                    if (+d[key] <= 0) {
                      val = 'n/a'
                      style = tableStyles.na
                    } else if (dataLabels[key].format === 'percent') {
                      if (d[key] < 0.0001) {
                        val = '<0.1%'
                      } else {
                        val = d[key].toLocaleString('en-US', {
                          style: 'percent',
                          minimumFractionDigits: 1,
                        })
                      }

                      style = tableStyles.numeric
                      bar = (
                        <div className={tableStyles.viz}>
                          <ProgressBar
                            data={[{ barStyle: key, val: d[key] }]}
                            total={1}
                            showLabels={false}
                            showBarLabels={false}
                            labeledById={labelKey}
                          />
                        </div>
                      )
                    } else if (!isNaN(+d[key])) {
                      //style numbers correctly
                      val = d[key].toLocaleString()
                      style = tableStyles.numeric
                    }
                  } else {
                    val = d[key]
                  }

                  return (
                    <td
                      className={
                        highlight ? `${tableStyles.highlight} ${style}` : style
                      }
                      key={`cell-${key}-${d[rowHeaderKey].replace(' ', '-')}`}
                    >
                      {bar ? (
                        <div className={tableStyles.vizContainer}>
                          {bar} <span id={labelKey}>{val}</span>
                        </div>
                      ) : (
                        val
                      )}
                    </td>
                  )
                })}
            </tr>
          ))}
        </tbody>
      </table>
      {data.length > maxLength && (
        <button onClick={() => toggleTable(phase)}>{btnText}</button>
      )}
    </div>
  )
}

export default DataTable
